// Packages
import getValue from "object-getvalue"

// Utils
import domUtil from "lib/dom/dom-util"
import { addtoDataLayer } from "components/Stacker/utils/DataLayer"
import { filterVariant } from "lib/utils/helpers"

// Constants
import PDC from "components/Stacker/constants/ProductDetailPageConstants"
import SWC from "components/Stacker/constants/SwatchConstants"
import TC from "components/Stacker/constants/TrackingConstants"
import SIWC from "components/Stacker/constants/StackItWithConstants"

// Configs
import ProductDetailsConfig from "components/Stacker/config/ProductDetailsConfig"
import CDS from "components/Stacker/constants/ContactCustomerCareConstants"
import { getDY_SR } from "stackerConfig"

// tracking

const shopTheLookDetails = getValue(
  { DY_SR: getDY_SR() },
  "DY_SR.data.shopTheLook"
)

let initialState = {
  queryParams: {
    baseStore: getValue(
      { DY_SR: getDY_SR() },
      "DY_SR.config.global.baseStore",
      ""
    ),
  },
  sizeChartView: "",
  sizeKit: {
    isDataLoading: false,
    isError: false,
    isSuccess: false,
    errorMessage: "",
  },
  currentQuickViewSelection: "",
  isCustomerCareMsgSucccess: false,
  isApplePayMounted: false,
  shopTheLookDetails: {},
  enableRopis: getValue(
    { DY_SR: getDY_SR() },
    "DY_SR.labels.ropis.enableRopis",
    true
  ),
  stackItWith: {
    stackItBundle: [],
    selectedIndex: 0,
    selectedStack: {
      title: "",
      description: "",
      stackProducts: [],
    },
    selectedStackedCodes: [],
    needCurrentStackPDPData: true,
  },
}

const getSelectedVariant = (options) => {
  const {
    variantOptions,
    selectedSwatch = {},
    isGiftCard = false,
    selectedGcCode = "",
  } = options
  let newSelectedVariantIndex = 0
  let newSelectedVariant = {}
  if (!isGiftCard) {
    if (selectedSwatch && Object.keys(selectedSwatch).length > 0) {
      const { selectedVariantCode, selectedVariantIndex } = selectedSwatch
      if (
        variantOptions[selectedVariantIndex] &&
        selectedVariantCode === variantOptions[selectedVariantIndex].code
      ) {
        newSelectedVariant = variantOptions[selectedVariantIndex]
        newSelectedVariantIndex = Number(selectedVariantIndex)
      } else {
        const { selectedVariant, selectedVariantIndex: colorIndex } =
          filterVariant({
            variantOptions,
            selectedVariantCode,
          })
        newSelectedVariant = { ...selectedVariant }
        newSelectedVariantIndex = colorIndex
      }
    }
  }
  //	For Gift Card set the selected Variant as per the code given in selectedGcCode
  if (isGiftCard) {
    if (selectedGcCode) {
      ;[newSelectedVariant] = variantOptions.filter((variant, index) => {
        if (variant.code === selectedGcCode) {
          newSelectedVariantIndex = index
        }
        return variant.code === selectedGcCode
      })
    }
  }

  if (!Object.keys(newSelectedVariant).length) {
    ;[newSelectedVariant] = variantOptions
  }

  return {
    selectedVariant: newSelectedVariant,
    selectedVariantIndex: newSelectedVariantIndex,
    selectedVariantTimeStamp: new Date().toISOString(),
  }
}

const updateDataLayer = (currentState, dataLayerName, isSwatchSelected) => {
  const { productView } = currentState.data
  const { selectedSize } = currentState
  if (
    productView &&
    Object.keys(productView).length &&
    productView.items?.length
  ) {
    const currentItem = productView.items[0]
    const { selectedVariant, priceInventory = {} } = currentState

    const { color, productName: name, code: sku } = selectedVariant
    const { price: { value: price } = {}, stock: { stockLevelStatus } = {} } =
      priceInventory

    const newProductViewData = {
      ...productView,
      items: [
        {
          ...currentItem,
          color,
          name,
          sku,
          price,
        },
      ],
    }
    newProductViewData.items[0].stocknotification =
      ProductDetailsConfig.NOSIZESELECTED
    if (selectedSize) {
      const { size, styleNumber } = selectedSize
      newProductViewData.items[0].size = size
      newProductViewData.items[0].sku = styleNumber
      newProductViewData.items[0].stocknotification =
        ProductDetailsConfig[stockLevelStatus]
    }

    addtoDataLayer(dataLayerName, newProductViewData)
  }

  // if (
  //   dataLayerName === TC.LAYER_PRODUCT_VIEW &&
  //   !isSwatchSelected &&
  //   selectedSize === undefined
  // ) {
  // }
  // if (dataLayerName === TC.LAYER_QUICK_VIEW && selectedSize === undefined) {
  // }
}

const getSelectedSize = (options) => {
  let { updatedVariant, selectedSizeCode } = options
  let {
    selectedVariant: { variantOptions },
  } = updatedVariant

  if ("size" in updatedVariant.selectedVariant) {
    selectedSizeCode = updatedVariant.selectedVariant.code
    variantOptions = [updatedVariant.selectedVariant]
  }

  let selectedSize = {}
  if (selectedSizeCode) {
    const { selectedVariant } = filterVariant({
      variantOptions,
      selectedVariantCode: selectedSizeCode,
    })
    selectedSize = { ...selectedVariant }
  }

  if (variantOptions.length === 1) {
    ;[selectedSize] = variantOptions
  }

  return selectedSize
}

const getProductTheme = (url) => {
  // Sample URL - https://stg3.davidyurman.com/products/mens/mens-rings/streamline-band-ring-in-18k-gold-6mm-r05996m88.pdp.html
  const productTheme = url.split("/")[2] === "mens" ? "men" : "women"
  // check if the same productTheme is already applied
  const bodyRef = domUtil.findFirst("body", null)
  const themeAlreadyApplied = domUtil.hasClass(bodyRef, productTheme)

  return {
    productTheme,
    themeAlreadyApplied,
  }
}

if (shopTheLookDetails && Object.keys(shopTheLookDetails).length > 0) {
  const { shopTheLookProducts } = shopTheLookDetails
  let finalLookProduct = {}
  const productIds = []

  shopTheLookProducts.forEach((lookProduct) => {
    const {
      products: {
        variantOptions,
        variantType,
        selectedGcCode,
        selectedVariant: selectedVariantIndex,
        productId,
        url,
      },
    } = lookProduct

    const selectedSwatch = {
      selectedVariantIndex,
      selectedVariantCode: variantOptions[selectedVariantIndex].code,
    }

    const isGiftCard =
      variantType === ProductDetailsConfig.GiftCardVariantProduct

    const updatedVariant = getSelectedVariant({
      selectedSwatch,
      variantOptions,
      isGiftCard,
      selectedGcCode,
    })

    // get the new productTheme to be applied
    const productThemeData = getProductTheme(url)

    productIds.push(productId)
    const selectedSize = getSelectedSize({
      updatedVariant,
    })

    const { selectedVariant: { price, stock } = {} } = updatedVariant

    finalLookProduct = {
      ...finalLookProduct,
      [productId]: {
        meta: {
          isDataLoaded: true,
          isError: false,
        },
        data: { ...lookProduct },
        ...updatedVariant,
        priceInventory: {
          price,
          stock,
        },
        isGiftCard,
        ...productThemeData,
        showProductDetails: false,
      },
    }
    if (Object.keys(selectedSize).length > 0) {
      finalLookProduct[productId].selectedSize = { ...selectedSize }
    }
  })

  const { title, imagePath, description, shopTheLookURL } = shopTheLookDetails

  initialState = {
    ...initialState,
    shopTheLookDetails: {
      title,
      imagePath,
      description,
      productIds,
      shopTheLookURL,
    },
    ...finalLookProduct,
  }
}

const setPDPData = (options) => {
  const {
    currentState,
    pdpData,
    pdpData: {
      products: {
        necklace_templete,
        width,
        variantOptions,
        url,
        variantType,
        selectedGcCode,
        canonicalTag,
      },
    },
    selectedSwatch,
    selectedSizeCode,
    productId,
  } = options
  const isGiftCard = variantType === "GiftCardVariantProduct"
  const updatedVariant = getSelectedVariant({
    variantOptions,
    selectedSwatch,
    isGiftCard,
    selectedGcCode,
    selectedSizeCode,
  })

  // get the new productTheme to be applied
  const productThemeData = getProductTheme(url)

  const selectedSize = getSelectedSize({
    updatedVariant,
    selectedSizeCode,
  })

  const isVehicle =
    necklace_templete === "TEMPLATE_2" ||
    updatedVariant.selectedVariant.necklace_templete === "TEMPLATE_2" //builderTemplate === "TEMPLATE_2"

  const pdpDataObj = {
    [productId]: {
      ...currentState[productId],
      meta: {
        isDataLoaded: true,
        isError: false,
        isVehicle,
        width,
      },
      data: { ...pdpData },
      ...updatedVariant,
      ...productThemeData,
      isGiftCard,
      canonicalUrl: canonicalTag,
    },
  }
  if (Object.keys(selectedSize).length > 0) {
    pdpDataObj[productId].selectedSize = { ...selectedSize }
  }
  return { ...pdpDataObj }
}

const setSelectedStackedCodes = (stackedItems) => {
  const { stackProducts } = stackedItems
  const selectedBaseProductCodes = []
  const selectedStackedCodes = []
  stackProducts.forEach((stack) => {
    const { baseProductCode, productCode: stackedVariantCode } = stack
    selectedBaseProductCodes.push(baseProductCode)
    selectedStackedCodes.push(`${baseProductCode}-${stackedVariantCode}`)
  })
  return {
    selectedBaseProductCodes,
    selectedStackedCodes,
  }
}

export default function ProductDetailPageReducer(
  previousState = initialState,
  action
) {
  let newState = previousState

  switch (action.type) {
    case PDC.PRODUCT_DETAIL_SUCCEED: {
      const { isStackedProducts = false } = action.payload

      if (isStackedProducts) {
        const { selectedStackedCodes, res: productDetails } = action.payload
        let getStackedPDPData = {}
        if (productDetails.length) {
          productDetails.forEach((pdpData, index) => {
            const selectedStackedCode = selectedStackedCodes[index]
            const {
              products: { productId },
            } = pdpData //	selectedVariantCode.split('-')[0];
            const currentPdpData = setPDPData({
              currentState: newState,
              pdpData,
              selectedSwatch: {
                selectedVariantCode: selectedStackedCode.split("-")[1],
                selectedVariantIndex: 0,
              },
              productId,
            })
            getStackedPDPData = {
              ...getStackedPDPData,
              ...currentPdpData,
              [selectedStackedCode]: {
                ...currentPdpData[productId],
              },
            }
          })
        }
        newState = {
          ...previousState,
          ...getStackedPDPData,
          stackItWith: {
            ...previousState.stackItWith,
            needCurrentStackPDPData: false,
            selectedStackedCodes,
          },
        }
        return newState
      }
      const {
        res: pdpData,
        selectedSwatch,
        selectedSizeCode,
        productId,
      } = action.payload
      const getPDPData = setPDPData({
        currentState: newState,
        pdpData,
        selectedSwatch,
        selectedSizeCode,
        productId,
      })
      newState = {
        ...previousState,
        ...getPDPData,
      }

      return newState
    }
    // case PDC.PRODUCT_DETAIL_FAILED:
    // 	newProductArray = {
    // 		...previousState
    // 	};
    // 	newProductArray[action.payload.productID] = {
    // 		meta: {
    // 			isDataLoaded: true,
    // 			isError: true,
    // 			message: action.payload.err
    // 		},
    // 		data: {}
    // 	};
    // 	return newProductArray;

    case PDC.QUICK_VIEW_SELECT: {
      newState = {
        ...previousState,
        currentQuickViewSelection: action.payload,
      }
      return newState
    }

    case PDC.QUICK_VIEW_CLEAR: {
      newState = {
        ...previousState,
        currentQuickViewSelection: "",
      }

      return newState
    }
    case SWC.SWATCH_SELECTED: {
      const {
        selectedVariantCode,
        selectedVariantIndex,
        isEditCart,
        selectedSizeCode: sizeCode,
        baseProductCode: productPid,
      } = action.payload
      if (previousState[productPid] && previousState[productPid].data) {
        const oldVariantOptions =
          previousState[productPid].data.products.variantOptions

        const selectedVariant = { selectedVariantCode, selectedVariantIndex }

        const newColorSwatch = getSelectedVariant({
          variantOptions: oldVariantOptions,
          selectedSwatch: selectedVariant,
        })

        delete previousState[productPid].selectedSize

        const selectedSize = getSelectedSize({
          updatedVariant: newColorSwatch,
          selectedSizeCode: isEditCart ? sizeCode : null,
        })
        newState = {
          ...previousState,

          [productPid]: {
            ...previousState[productPid],
            ...newColorSwatch,
            sizeSelectionError: false,
            notifyEmail: {
              isError: false,
              isSuccess: false,
              errorMessage: "",
              message: "",
            },
          },
        }
        if (Object.keys(selectedSize).length > 0) {
          newState[productPid].selectedSize = { ...selectedSize }
        }
        // event for color selection on plp, pdp and shopping bag - Edit product
        // updating data layer to capture selected product color while firing event
        const isSwatchSelected = true
        updateDataLayer(
          newState[productPid],
          TC.LAYER_PRODUCT_VIEW,
          isSwatchSelected
        )
        return newState
      }

      return {
        ...previousState,
      }
    }
    case PDC.PRODUCT_INVENTORY_SUCCEED: {
      const {
        res,
        productType,
        productId: productIds,
        shouldUpdateDataLayer,
        pid: productCode,
        shouldUpdateQuickViewLayer,
        isEditShoppingBag,
      } = action.payload
      let priceInventory = {}

      if (productType === ProductDetailsConfig.BASE_PRODUCT) {
        const swatchCode = productIds.split(",")[0]
        ;[priceInventory] = res.filter((option) => {
          return swatchCode === option.productId
        })
      } else {
        ;[priceInventory] = res.filter((option) => {
          return productIds === option.productId
        })
      }

      newState = {
        ...previousState,

        [productCode]: {
          ...previousState[productCode],
          priceInventory: { ...priceInventory },
          notifyEmail: {
            isError: false,
            isSuccess: false,
            errorMessage: "",
          },
        },
      }
      if (shouldUpdateDataLayer) {
        updateDataLayer(newState[productCode], TC.LAYER_PRODUCT_VIEW)
      }

      if (shouldUpdateQuickViewLayer) {
        updateDataLayer(newState[productCode], TC.LAYER_QUICK_VIEW)
      }

      if (isEditShoppingBag) {
        updateDataLayer(newState[productCode], TC.LAYER_PRODUCT_COLOR_SELECTED)
      }

      return newState
    }
    case PDC.PRODUCT_INVENTORY_FAILED: {
      const { selectedVariant: colorVariant, selectedSize } =
        previousState[action.payload.pid]

      const currentSelectedVariant = selectedSize || colorVariant

      const { price, stock } = currentSelectedVariant
      return {
        ...previousState,
        [action.payload.pid]: {
          ...previousState[action.payload.pid],
          priceInventory: { price, stock },
        },
      }
    }

    case PDC.SET_SELECTED_SIZE: {
      const {
        pid,
        sizeObj,
        sizeObj: { code: sizeCodeSelected },
      } = action.payload
      let imageVariants = []
      if (previousState[pid]) {
        const { selectedVariant: { variantOptions = [] } = {} } =
          previousState[pid]
        if (Array.isArray(variantOptions) && variantOptions.length) {
          variantOptions.every((Colorvariant) => {
            if (getValue(Colorvariant, "code", "") === sizeCodeSelected) {
              imageVariants = getValue(Colorvariant, "imageVariants", [])
              return false
            }
            return true
          })
        }
      }

      return {
        ...previousState,
        [pid]: {
          ...previousState[pid],
          selectedSize: { ...sizeObj, imageVariants },
          sizeSelectionError: false,
        },
      }
    }

    case PDC.PDP_SET_SIZE_SELECTION_ERROR:
      return {
        ...previousState,
        [action.payload.pid]: {
          ...previousState[action.payload.pid],
          sizeSelectionError: action.payload.value,
        },
      }

    case PDC.PDP_RESET_SIZE_SELECTION_ERROR:
      return {
        ...previousState,
        [action.payload.pid]: {
          ...previousState[action.payload.pid],
          sizeSelectionError: false,
        },
      }

    case PDC.PDP_PROMO_SUCCEED:
      return {
        ...previousState,
        [action.payload.pid]: {
          ...previousState[action.payload.pid],
          promosToRender: action.payload.promos,
          notifyEmail: {
            isError: false,
            isSuccess: false,
            errorMessage: "",
          },
        },
      }

    case PDC.PDP_PROMO_FAILED:
      return {
        ...previousState,
        [action.payload.pid]: {
          ...previousState[action.payload.pid],
          promosToRender: [],
        },
      }
    case PDC.SET_SELECTED_GIFT_AMOUNT:
      return {
        ...previousState,
        [action.payload.pid]: {
          ...previousState[action.payload.pid],
          selectedVariant: { ...action.payload.amountObj },
        },
      }

    // For resetting the success message flag for contact customer care form
    case CDS.CUSTOMER_CARE_SUBMIT_FORM_SUCCESS:
      return {
        ...previousState,
        isCustomerCareMsgSucccess: true,
      }

    case CDS.CUSTOMER_CARE_SUBMIT_FORM_RESET:
      return {
        ...previousState,
        isCustomerCareMsgSucccess: false,
      }
    case PDC.TOGGLE_PRODUCT_DETAILS:
      return {
        ...previousState,
        [action.payload.pid]: {
          ...previousState[action.payload.pid],
          showProductDetails:
            !previousState[action.payload.pid].showProductDetails,
        },
      }
    case SIWC.STACK_IT_RESPONSE_SUCCESS: {
      const { stackItBundle, isEngagementStack } = action.payload

      const selectedStackData = setSelectedStackedCodes(stackItBundle[0])

      return {
        ...previousState,
        stackItWith: {
          ...previousState.stackItWith,
          stackItBundle,
          isEngagementStack,
          ...selectedStackData,
          needCurrentStackPDPData: true,
        },
      }
    }
    case SIWC.STACK_IT_SET_SELECTED_STACK: {
      const { selectedStack } = action.payload

      const getSelectedStackData = setSelectedStackedCodes(selectedStack)

      const { selectedStackedCodes } = getSelectedStackData
      let hasStackedPDPData = true
      selectedStackedCodes.forEach((code) => {
        const stackedData = previousState[code]
        if (hasStackedPDPData) {
          hasStackedPDPData = stackedData && Object.keys(stackedData).length > 0
        }
      })
      return {
        ...previousState,
        stackItWith: {
          ...previousState.stackItWith,
          ...getSelectedStackData,
          needCurrentStackPDPData: !hasStackedPDPData,
        },
      }
    }

    case SIWC.SET_SELECTED_STACK_METAL: {
      const { metalCode, stackedCode } = action.payload
      const exisitingPdpData = previousState[metalCode]
      if (exisitingPdpData) {
        return {
          ...previousState,
          [stackedCode]: {
            ...exisitingPdpData,
          },
        }
      }
      return {
        ...previousState,
        [stackedCode]: {
          selectedMetal: metalCode,
          getPdpData: true,
        },
      }
    }
    case SIWC.STACK_IT_RESPONSE_FAILED:
      return {
        ...previousState,
        stackItWith: {
          ...initialState.stackItWith,
        },
      }
    case SIWC.STACK_IT_WITH_SET_NEED_PDP_DATA:
      return {
        ...previousState,
        stackItWith: {
          ...previousState.stackItWith,
          needCurrentStackPDPData: true,
        },
      }
    case SIWC.STACK_IT_CART_ADD_SUCCESSFULL:
      return {
        ...previousState,
        [action.payload.stackedCode]: {
          ...previousState[action.payload.stackedCode],
          hasCartAddtionError: false,
          errorMessage: "",
        },
      }
    case SIWC.STACK_IT_CART_ADD_FAILED:
      return {
        ...previousState,
        [action.payload.stackedCode]: {
          ...previousState[action.payload.stackedCode],
          hasCartAddtionError: true,
          errorMessage: action.payload.error,
        },
      }

    case SIWC.STACK_IT_RESET:
      return initialState

    case PDC.APPLE_PAY_MOUNTED:
      return {
        ...previousState,
        isApplePayMounted: true,
      }

    case PDC.APPLE_PAY_UNMOUNTED:
      return {
        ...previousState,
        isApplePayMounted: false,
      }
    case PDC.PDP_SET_SIZE_CHART_VIEW:
      return {
        ...previousState,
        sizeChartView: action.payload,
      }
    case PDC.SIZE_KIT_ORDER_IN_PROGRESS:
      return {
        ...previousState,
        sizeKit: {
          isDataLoading: true,
          isError: false,
          isSuccess: false,
          errorMessage: "",
        },
      }
    case PDC.SIZE_KIT_ORDER_SUCCESS:
      return {
        ...previousState,
        sizeKit: {
          isDataLoading: false,
          isError: false,
          isSuccess: true,
          errorMessage: "",
        },
      }
    case PDC.SIZE_KIT_ORDER_ERROR:
      return {
        ...previousState,
        sizeKit: {
          isDataLoading: false,
          isError: true,
          isSuccess: false,
          errorMessage: action.payload.errorMessage,
        },
      }
    case PDC.SIZE_KIT_FORM_RESET:
      return {
        ...previousState,
        sizeKit: {
          isDataLoading: false,
          isError: false,
          isSuccess: false,
          errorMessage: "",
        },
      }
    case PDC.NOTIFY_USER_FORM_FAILURE:
      return {
        ...previousState,
        [action.payload.pid]: {
          ...previousState[action.payload.pid],
          notifyEmail: {
            isError: true,
            isSuccess: false,
            errorMessage: action.payload.errorMessage,
            successMessage: "",
          },
        },
      }
    case PDC.NOTIFY_USER_FORM_SUCCESS:
      return {
        ...previousState,
        [action.payload.pid]: {
          ...previousState[action.payload.pid],
          notifyEmail: {
            isError: false,
            isSuccess: true,
            errorMessage: "",
            message: action.payload.message,
          },
        },
      }
    case PDC.NOTIFY_USER_FORM:
      return {
        ...previousState,
        [action.payload.pid]: {
          ...previousState[action.payload.pid],
          notifyEmail: {
            isError: false,
            isSuccess: false,
            errorMessage: "",
            message: "",
          },
        },
      }
    case PDC.METAL_SELECTED:
      return {
        ...previousState,
        currentQuickViewSelection: {
          pid: action.payload.pid,
          url: action.payload.url,
        },
      }
    default:
      return previousState
  }
}
